import { Chip } from '@mui/material'

const palette = (value: string): { color: string, bg: string } => {
  if (value === 'Yes') return { color: 'var(--green-700)', bg: 'var(--green-50)' }
  if (value.startsWith('N/A')) return { color: 'var(--grey-500)', bg: 'var(--grey-100)' }
  return { color: 'var(--red-500)', bg: 'var(--red-50)' }
}

export const StatusPill = ({ value }: { value: string }): JSX.Element => {
  const { color, bg } = palette(value)
  return <Chip label={value} size='small' sx={{ backgroundColor: bg, color, fontWeight: 600 }} />
}
